export default "__VITE_ASSET__C9$8MK10__"